import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function splitContactNumbers(value) {
  if (value == null || value === "") return [];
  return String(value)
    .split(/[,;/|]/)
    .map((number) => number.trim())
    .filter(Boolean);
}

export function primaryContactNumber(value) {
  return splitContactNumbers(value)[0] || "";
}
